import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Menu } from 'lucide-react'
import { AppSidebar } from './AppSidebar'
import { UserAvatarMenu } from '@/components/common/UserAvatarMenu'
import { PortfolioSwitcher } from '@/components/common/PortfolioSwitcher'
import { usePricesPolling } from '@/store/usePrices'

export const AppLayout: React.FC = () => {
  // Chạy polling prices + fx rates 1 lần cho toàn app
  usePricesPolling()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <AppSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0">
        <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
          <button onClick={() => setSidebarOpen(true)} className="lg:hidden p-2 rounded-md hover:bg-gray-100">
            <Menu className="w-5 h-5" />
          </button>
          <div className="lg:hidden" />
          <div className="hidden lg:block">
            <PortfolioSwitcher />
          </div>
          <div className="flex items-center gap-3">
            <div className="lg:hidden">
              <PortfolioSwitcher />
            </div>
            <UserAvatarMenu />
          </div>
        </header>
        <main className="flex-1 px-4 py-5 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
